<template>
  <Photos year="2023" :min-date="1679961600" :max-date="1680220800" date-text="March 28&ndash;31" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
